import { render } from "./resource-administration.vue?vue&type=template&id=2a16f59b&scoped=true"
import script from "./resource-administration.vue?vue&type=script&lang=js"
export * from "./resource-administration.vue?vue&type=script&lang=js"

import "./resource-administration.vue?vue&type=style&index=0&id=2a16f59b&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Library/Containers/com.tencent.xinWeChat/Data/Documents/xwechat_files/wxid_1rhhjrwiu7uq22_9030/msg/file/2026-08/ubang-copilot-agents-web-deploy-2026-08-31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a16f59b"]])

export default __exports__